module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture13-61797cde7f3e25970fb357f358dedd6d.jpg";